import React from 'react'

import { ButtonFilter } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object } from 'prop-types'

import SmartTooltip from 'Pods/ItemPage/Components/SmartTooltip'

function CustomButtonFilter({ tooltip, ...props }) {
  const buttonFilter = (
    <ButtonFilter
      imageAttributes={{
        fetchpriority: 'low',
        width: '100',
        height: '75',
      }}
      {...props}
    />
  )

  if (!tooltip) {
    return buttonFilter
  }

  return (
    <SmartTooltip
      id={tooltip.id}
      content={tooltip.content}
      delayHide={100}
      delayUpdate={100}
      autoPosition
      containerSelector=".cgt-model-search__tag-list-tags"
    >
      {buttonFilter}
    </SmartTooltip>
  )
}

CustomButtonFilter.propTypes = {
  tooltip: object,
}

export default CustomButtonFilter
